import type { SearchEngineEventItem } from '~/composables/types/searchEngine'
import type { EventDescription } from '~/composables/types/event'
import { searchEngineEventGetters } from '~/utils/searchEngineEventGetters'
import { eventGetters } from '~/utils/eventGetters'

const isEventDescription = (
  data: SearchEngineEventItem | EventDescription
): data is EventDescription => {
  return (
    (data as EventDescription).object === 'EventMetaData' ||
    !!(data as EventDescription).supplier?.data
  )
}

export const parseKftEventToGtmItemListItem = (
  data: SearchEngineEventItem | EventDescription
) => {
  // Handle EventDescription (from API, e.g., kits)
  if (isEventDescription(data)) {
    const eventTitle = eventGetters.getTitle(data)
    const eventId = eventGetters.getId(data)
    const partnerName = eventGetters.getSupplierName(data) || ''
    const category = eventGetters.getMainCategory(data) || null
    const eventPriceAmount = eventGetters.getDefaultPriceAmount(data)
    const eventPrice = eventPriceAmount
      ? parseInt(String(eventPriceAmount)) / 100
      : 0

    return {
      item_id: eventId,
      item_name: eventTitle,
      item_category: category,
      item_brand: partnerName,
      price: eventPrice.toFixed(2),
      google_business_vertical: 'custom',
    }
  }

  // Handle SearchEngineEventItem (from Algolia search)
  const eventTitle = searchEngineEventGetters.fnGetTitle(data)
  const eventId = searchEngineEventGetters.fnGetHashedId(data)
  const partnerName = searchEngineEventGetters.fnGetSupplier(data)
  const category = searchEngineEventGetters.fnGetMainCategory(data)
  const eventPrice = searchEngineEventGetters.getPriceAmount(data)

  return {
    item_id: eventId,
    item_name: eventTitle,
    item_category: category,
    item_brand: partnerName,
    price: (eventPrice / 100).toFixed(2),
    google_business_vertical: 'custom',
  }
}
